/**
 * Returns the singular or plural translation based on the count.
 */
export function getPluralOrSingularTranslation(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1 ? singular : plural;
}
